import { useState, useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import routes from "./constants/routes";
import AppLayout from "./components/layouts/AppLayout";
import { Amplify, Auth } from "aws-amplify";
import config from "./config";
import UserContext from "./contexts/user";
import { SocketContextWrapper } from "./contexts/socket";
import Home from "./pages/home";
import Plans from "./pages/plans";
import Blogs from "./pages/blogs";
import Blog from "./pages/blog";
import Contact from "./pages/contact";
import Ledger from "./pages/ledger";
import Docket from "./pages/docket";
import Bite from "./pages/bite";
import Register from "./pages/register";
import Successful from "./pages/successful";
import Onboarding from "./pages/onboarding";
import { withRoot } from "./withRoot";
import theme from "./config/theme";

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
});

function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        if (currentUser) {
          setUser(currentUser?.attributes);
          setUserRole(
            currentUser?.attributes && currentUser?.attributes["custom:type"]
          );
        }
      } catch (err) {
        console.error(err);
      }
    };
    verifyUser().catch(console.error);
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <UserContext.Provider value={{ user, setUser, userRole, setUserRole }}>
        <SocketContextWrapper>
          <Router>
            <CssBaseline />
            <Routes>
              <Route path="*" element={<Navigate to={routes.HOME} replace />} />
              <Route
                path={routes.HOME}
                element={
                  <AppLayout>
                    <Home />
                  </AppLayout>
                }
              />
              <Route
                path={routes.PLANS}
                element={
                  <AppLayout>
                    <Plans />
                  </AppLayout>
                }
              />
              <Route
                path={routes.BLOGS}
                element={
                  <AppLayout>
                    <Blogs />
                  </AppLayout>
                }
              />
              <Route
                path={routes.BLOG}
                element={
                  <AppLayout>
                    <Blog />
                  </AppLayout>
                }
              />
              <Route
                path={routes.CONTACT}
                element={
                  <AppLayout>
                    <Contact />
                  </AppLayout>
                }
              />
              <Route
                path={routes.LEDGER}
                element={
                  <AppLayout>
                    <Ledger />
                  </AppLayout>
                }
              />
              <Route
                path={routes.DOCKET}
                element={
                  <AppLayout>
                    <Docket />
                  </AppLayout>
                }
              />
              <Route
                path={routes.BITE}
                element={
                  <AppLayout>
                    <Bite />
                  </AppLayout>
                }
              />
              <Route path={routes.REGISTER} element={<Register />} />
              <Route path={routes.SUCCESSFUL} element={<Successful />} />
              <Route
                path={routes.ONBOARDING}
                element={
                  <AppLayout>
                    <Onboarding />
                  </AppLayout>
                }
              />
            </Routes>
          </Router>
        </SocketContextWrapper>
      </UserContext.Provider>
    </ThemeProvider>
  );
}

export default withRoot(App);
